// extracted by mini-css-extract-plugin
export default {"appContainer":"styles_appContainer__KkpQj"};